import { ChangeType } from "./changetracked";

export class RecordableCategory {
    public id: number;
    public categoryName: string;
}

export class RecordableCategoryUpdate extends RecordableCategory {
    public changeType?: ChangeType = ChangeType.Unchanged;
}
